import { Injectable } from '@angular/core';
import { HttpRequestModel, HttpService } from '../httpservice/http.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class JobPermitTypeService {
  HttpRequestModel: HttpRequestModel = new HttpRequestModel();

  constructor(private httpService: HttpService) {}

  //Request to get all job permit type
  getJobPermitType(jobId, searchInfo = null, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_job_permit_type/' + jobId;
    this.HttpRequestModel.method = 'GET';
    this.HttpRequestModel.body = '';

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to create job permit type
  createJobPermitType(jobPermitTypeInfo, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_job_permit_type/add';
    this.HttpRequestModel.method = 'POST';
    this.HttpRequestModel.body = jobPermitTypeInfo;

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to update job permit type
  updateJobById(jobPermitTypeId, jobPermitTypeData, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_job_permit_type/update/' + jobPermitTypeId;
    this.HttpRequestModel.method = 'PUT';
    this.HttpRequestModel.body = jobPermitTypeData;

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to delete job permit type by id
  deleteJobPermitType(jobId, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_job_permit_type/delete/' + jobId;
    this.HttpRequestModel.method = 'DELETE';
    this.HttpRequestModel.body = '';

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }
}
